module.exports = __webpack_public_path__ + "static/media/windGust.398e352e.svg";